import React from 'react';

const AppSettings = React.createContext();

const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-30%',
      transform: 'translate(-50%, -50%)',
    },
  };

export {customStyles, AppSettings}
